<mat-card>
    <mat-card-content class="layoutGap-8">
        @if (canAddChange()) {
            <button
                mat-raised-button
                color="primary"
                (click)="createChange()"
                [disabled]="currentUserTeams.length < 1"
            >
                Add Change
            </button>
        }
        @if (numberofPendingChangeRecords > 0) {
            <span>
                @if (canSubmitChangeForPricing()) {
                    <button (click)="submitChanges()" mat-raised-button color="primary">
                        Submit For Pricing ({{ numberofPendingChangeRecords }})
                    </button>
                }
            </span>
        }
        @if (canCreateVariation()) {
            <button
                [disabled]="!canGenerateVariations()"
                mat-raised-button
                color="primary"
                (click)="openGenerateVariationDialog($event)"
            >
                Generate Variation ({{ $numberofUnassignedChangeRecords }})
            </button>
        }
        @if (canGenerateChangesSignOffDocument()) {
            <button
                [disabled]="!isGenerateChangesSignOffDocumentEnabled()"
                mat-raised-button
                color="primary"
                (click)="generateChangesSignOffDocument()"
            >
                Generate Changes Signoff Document
            </button>
        }
    </mat-card-content>
</mat-card>
